import { render } from "./cooperate.vue?vue&type=template&id=8b596dd0&scoped=true"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"

import "./cooperate.vue?vue&type=style&index=0&id=8b596dd0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b596dd0"]])

export default __exports__